import {
  parseGetRows, setFilteredCustomRows,
} from '@/utils/manageGetRows';
import SortRowsFactory from '@/utils/sorting/SortRowsFactory';
import productHeaders from '@/constants/productHeaders';
export const getters = {
  listDeletedRowsForRendering(state) {
    let { listDeletedRows } = state;
    const listOfRows = listDeletedRows.map(row => ({
      id: row.fields.find(item => item.name === 'id')?.value,
      type: row.fields.find(item => item.name === productHeaders.TYPE_DESIGNATION)?.value,
    }));
    return listOfRows;
  },
  viewInfoLength(state) {
    return state.viewInfo.length;
  },
  mappedDataRows(state, getters) {
    const { sortedViewInfo: data } = getters;
    return data.map(({ id, [productHeaders.TYPE_DESIGNATION]: initType = '' } = {
    }) => {
      const val = initType?.toString()?.trim();
      const type = (!val || val === '\b') ? '---' : initType;
      return {
        type,
        id,
      };
    });
  },
  currentRowItem(state, getters, rootState) {
    const { viewInfo: data } = state;
    const { modalRowId: id } = rootState.ProjectDetailsTableSchedule;
    return data.find(row => row.id === id);
  },
  arrTypeDesignation(state) {
    return state.viewInfo.map(e => ({
      name: e[productHeaders.TYPE_DESIGNATION],
      id: e.id,
    })).filter(e => e?.name);
  },
  sortedViewInfo(state, getters, rootState, rootGetters) {
    const sortingData = rootGetters['ScheduleViews/sortingData'];
    return getters.getSortedViewInfo(sortingData);
  },
  getSortedViewInfo: (state, getters, rootState, rootGetters) => (sortingData) => {
    const customViewRows = rootState.ProjectDetailsTableSchedule.customViewRows;
    const sortedData = new SortRowsFactory({
      sortOrder: sortingData?.sortOrder,
      sortBy: sortingData?.sortBy,
      items: customViewRows ? customViewRows : state.viewInfo,
    }).sort();
    const selectedTag = rootGetters['ScheduleViews/selectedViewTag'];
    if (selectedTag && !customViewRows) {
      /**
       * Returns a filtered array of custom rows.
       *
      * @returns {Array} The filtered array of custom rows.
       */
      return setFilteredCustomRows({
        arr: sortedData,
        selectedTag,
        checkCompareRow: true,
      });
    }
    return sortedData;
  },
  viewInfoWithDeletedComparedRows(state, getters, rootState, rootGetters) {
    const { sortedViewInfo: data } = getters;
    const rows = rootGetters['ScheduleCompare/deletedComparedRows'];
    if (!rows.length) return data;
    return rows.reduce((result, { fields = [], rowId: id }) => {
      if (!id) return result;
      const isRowExist = data.some(({ id: i } = {
      }) => i === id);
      if (isRowExist) return result;
      const obj = {
        ...parseGetRows(fields),
        isCompared: true,
      };
      return [...result, obj];
    }, [...data]);
  },
  viewInfoWithModifiedRow(state, getters, rootState) {
    const { viewInfoWithDeletedComparedRows: data = [] } = getters;
    const { modifiedRow: row } = rootState.ScheduleCompare;
    if (!row) return data;
    const { rowId = null, fields = [] } = row;
    const index = data.findIndex(({ id = null } = {
    }) => id === rowId);
    if (index === -1) return data;
    const obj = {
      ...parseGetRows(fields),
      isCompared: true,
    };
    return data.reduce((result, option, idx) => {
      if (idx === index) return [...result, option, obj];
      return [...result, option];
    }, []);
  },
  viewInfoToRendering(state, getters, rootState) {
    const { compareListWithVersions = [] } = rootState.ScheduleCompare;
    const { viewInfoWithModifiedRow: data = [] } = getters;
    return data.reduce((result, option) => {
      const {
        modified = [],
        status = '',
        rowId = '',
      } = compareListWithVersions.find(({ rowId } = {
      }) => rowId === option.id) ?? {
      };
      return [
        ...result,
        {
          ...option,
          compareData: {
            modified: Array.isArray(modified) ? modified : [],
            status,
            rowId,
          },
        },
      ];
    }, []);
  },
  loadedRowsTitle(state, getters, rootState, rootGetters) {
    const rowsCount = rootGetters['ProjectDetails/rowsCount'];
    const { viewInfoLength: infoLength } = getters;
    const GETTING_ROWS_TITLE = 'Getting rows';
    if (isNaN(rowsCount)) {
      return GETTING_ROWS_TITLE;
    }
    return `${GETTING_ROWS_TITLE} (${infoLength}/${rowsCount})`;
  },
  isMultipleRowsSelected(state) {
    return state.checkboxSelectedRows && !!state.checkboxSelectedRows.length;
  },
};
